// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vc-chrome{box-shadow:none!important}.vc-chrome-body{padding-bottom:0!important}", ""]);
// Exports
module.exports = exports;
